import { render, staticRenderFns } from "./info_pc.vue?vue&type=template&id=ed558b30&scoped=true&"
import script from "./info_pc.vue?vue&type=script&lang=js&"
export * from "./info_pc.vue?vue&type=script&lang=js&"
import style0 from "./info_pc.vue?vue&type=style&index=0&id=ed558b30&lang=less&scoped=true&"
import style1 from "./info_pc.vue?vue&type=style&index=1&id=ed558b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed558b30",
  null
  
)

export default component.exports